export { IntegrationAppAsideInfo } from './IntegrationAppAsideInfo/IntegrationAppAsideInfo'
export { IntegrationAppDetails } from './IntegrationAppDetails/IntegrationAppDetails'
export { IntegrationAppHeader } from './IntegrationAppHeader/IntegrationAppHeader'
export { IntegrationAppPremiumCTA } from './IntegrationAppPremiumCTA/IntegrationAppPremiumCTA'

export const SCROLL_ANCHOR = 'HOW_TO_CONNECT_VIA_ZAPIER'
